export default "__VITE_ASSET__CZkLBnSG__"